<template>
  <DetailContainer>
    <PageHeader
      slot="page-header"
      showBack
      showBreadcrumb
      @back="$router.push({ name: 'IceDevice' })"
    ></PageHeader>
    <div slot="top" class="info">
      <div class="info-content">
        <div class="info-header">
          <div class="status-icon">
            <hl-status
              class="online"
              :iconClass="(onOffLineStatus[info.online] || {})['iconClass']"
              :color="(onOffLineStatus[info.online] || {})['color']"
              :title="info.onlineName"
            ></hl-status>
            <!--            <div class="device">-->
            <!--              <hl-status-->
            <!--                class="device-dot"-->
            <!--                :color="(deviceStatus[info.state] || {})['color']"-->
            <!--                :title="info.stateName"-->
            <!--              ></hl-status>-->
            <!--            </div>-->
          </div>
          <div style="flex: 1">
            <h3 class="name">{{ info.code | format }}</h3>
            <div class="address">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-address"></use>
              </svg>
              {{ info.installationAreaName | format }}
            </div>
          </div>
          <div class="btPart">
            <hl-button @click="initSet" type="secondary" v-if="initDataRole">
              {{ $t('Device.initSet') }}
            </hl-button>
            <hl-button @click="remoteControl" type="secondary" v-if="remoteControlRole">
              {{ $t('Device.remoteControl') }}
            </hl-button>
            <hl-button @click="handleParamsSet" v-if="paramsSetRole">
              {{ $t('Device.paramsSet') }}
            </hl-button>
          </div>
        </div>
        <el-tabs v-model="descActiveTabName" class="device-detail-tabs">
          <el-tab-pane :label="$t('Common.BasicInfo')" name="basicInfo">
            <div class="info-desc-part">
              <div class="info-desc">
                <Descriptions :gutter="24">
                  <DescriptionsItem labelWidth="auto" :span="8" :label="$t('Device.customerName')">
                    {{ info.customerName | format }}
                  </DescriptionsItem>
                  <DescriptionsItem
                    labelWidth="auto"
                    :span="8"
                    :label="$t('Device.warrantyPeriod')"
                  >
                    <span id="warrantyPeriod" style="margin-right: 4px">
                      {{ info.warrantyPeriod | format }}
                    </span>
                    {{ $t('Device.unitDay') }}
                  </DescriptionsItem>
                  <DescriptionsItem labelWidth="auto" :span="8" :label="$t('Common.ip')">
                    {{ info.ip | format }}
                  </DescriptionsItem>
                  <DescriptionsItem
                    labelWidth="auto"
                    :span="8"
                    :label="$t('Device.installationTime')"
                  >
                    {{ info.installationTime | formatTime('YYYY-MM-DD') }}
                  </DescriptionsItem>
                  <DescriptionsItem labelWidth="auto" :span="8" :label="$t('Device.deadline')">
                    {{ info.expirationDate | formatTime('YYYY-MM-DD') }}
                  </DescriptionsItem>
                  <DescriptionsItem labelWidth="auto" :span="8" :label="$t('Device.activeTime')">
                    {{ info.activationTime | formatTime('YYYY-MM-DD') }}
                  </DescriptionsItem>
                  <DescriptionsItem labelWidth="auto" :span="8" :label="$t('Device.WIFIDTUModel')">
                    {{ info.version | format }}
                  </DescriptionsItem>
                  <DescriptionsItem
                    labelWidth="auto"
                    :span="8"
                    :label="$t('Common.lastCommunicationTime')"
                  >
                    {{ info.lastCommunicationTime | formatTime }}
                  </DescriptionsItem>
                  <DescriptionsItem
                    labelWidth="auto"
                    :span="8"
                    :label="$t('Device.isInExpirationDate')"
                  >
                    <hl-tag
                      plain
                      :color="(limitTimeStatusTag[info.isInExpirationDate] || {})['color']"
                      :borderColor="(limitTimeStatusTag[info.isInExpirationDate] || {})['color']"
                    >
                      {{ info.inExpirationDateName }}
                    </hl-tag>
                  </DescriptionsItem>
                  <DescriptionsItem labelWidth="auto" :span="8" :label="$t('Device.productModel')">
                    {{ info.productName | format }}
                  </DescriptionsItem>
                  <DescriptionsItem labelWidth="auto" :span="8" :label="$t('Device.factoryArea')">
                    {{ info.factoryArea | format }}
                  </DescriptionsItem>
                </Descriptions>
              </div>
              <!--          v-if="info.online === 'online'"-->
              <div class="deviceStatus">
                <div class="temperature-card">
                  <div>
                    <div class="device-temperature">
                      {{ DeviceTemperatureWithUnit | format }}{{ this.deviceTempUnit }}
                    </div>

                    <div class="device-temperature-tips">{{ $t('Device.currentTemperature') }}</div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('Device.stateInfo')" name="stateInfo">
            <div class="info-desc-part">
              <div class="info-desc">
                <div v-for="(item, i) in statusList" :key="i" class="info-desc-part-item">
                  <div v-if="stateConfigs.some((x) => x.paramKey === item.code)">
                    <hl-image
                      :src="item.iconId ? createImgUrl(item.iconId) : ''"
                      width="24px"
                      height="24px"
                      class="image"
                    ></hl-image>
                    <span class="statusName">{{ item.name }}:</span>
                    <span class="statusName">{{ item.status }}</span>
                  </div>
                </div>
              </div>

              <div class="deviceStatus">
                <div class="temperature-card">
                  <div>
                    <div class="device-temperature">
                      <!--                      {{ deviceTemperature | format }}{{ deviceTempUnit }}-->
                      {{ DeviceTemperatureWithUnit | format }}{{ this.deviceTempUnit }}
                    </div>
                    <div class="device-temperature-tips">{{ $t('Device.currentTemperature') }}</div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <!--      <div class="deviceStatus" v-if="info.online === 'online'">-->
      <!--      </div>-->
    </div>

    <DeviceDetailTable :productKey="info.productKey" :deviceCode="info.code" />
    <RemoteControl
      v-if="remoteControlVisible"
      :visible.sync="remoteControlVisible"
      :productKey="info.productKey"
      :info="info"
    />
    <ParamentsSet
      v-if="paramentsSetVisible"
      :visible.sync="paramentsSetVisible"
      :productKey="info.productKey"
      :info="info"
    />
  </DetailContainer>
</template>

<script>
import { Message } from 'element-ui'

let client = null
let timer = null
import ClipboardJS from 'clipboard'
import Tag from '@/components/CommonTable/Tag'
import DetailContainer from '@/components/DetailContainer/index'
import Descriptions from '@/components/Descriptions'
import DescriptionsItem from '@/components/Descriptions/DescriptionsItem'
import Status from '@/components/CommonTable/Status'
import DeviceDetailTable from './DetailTable/index'
import { format, formatTime, formatNumWithComma } from '@/utils/utils'
import { deviceStatus, onOffLineStatus, iceDeviceStatus } from '@/config/status'
import { productTypeTag, limitTimeStatusTag, iceDeviceStatusTag } from '@/config/tag'
import { createMqttClient, topicPrefix } from '@/utils/mqttClient'
import i18n from '@/locales/index'
import { iceParams } from '@/config/iceParams.js'
import { dec2hex, hex_to_bin, hex_to_dec_sign, fixNum, createImgUrl, CToF } from '@/utils/utils'
import ParamentsSet from './components/ParamentsSet'
import RemoteControl from './components/RemoteControl'
import getRoleFromPath from '@/mixins/getRoleFromPath'
import { getRoleByOperationCode, getRoute } from '@/authorized'
import Image from '@/components/CommonTable/Image'
import { mapState } from 'vuex'
const mqttState = {
  loading: 'loading',
  fail: 'fail',
  success: 'success'
}
const mqttStateNameEnum = {
  loading: i18n.t('Common.loading'),
  fail: i18n.t('Common.connFail'),
  success: i18n.t('Common.connSuccess')
}
export default {
  mixins: [getRoleFromPath],
  components: {
    DetailContainer,
    Descriptions,
    DescriptionsItem,
    'hl-status': Status,
    'hl-tag': Tag,
    'hl-image': Image,
    DeviceDetailTable,
    ParamentsSet,
    RemoteControl
  },

  data() {
    return {
      iceParams,
      mqttState,
      mqttConnectState: mqttState.loading,
      deviceStatus,
      onOffLineStatus,
      productTypeTag,
      limitTimeStatusTag,
      iceDeviceStatus,
      iceDeviceStatusTag,
      info: {},
      deviceId: this.$route.query.id,
      activeTabName: 'first',
      //downTopic: `${topicPrefix}mqtt/${this.$route.query.id}/down`,
      downTopic: '',
      upTopic: '',
      deviceIceStatus: {},
      cookStatusLoading: false,
      statusList: [],
      descActiveTabName: 'basicInfo',
      paramentsSetVisible: false,
      remoteControlVisible: false,
      deviceTemperature: '', //柜温
      deviceTemperatureC: 0.1, //柜温系数
      stateConfigs: [], //状态信息模板
      deviceTempUnit: '', //温度单位
      propertyList: [], //物模型属性
      needShowPropertyList: [] //根据模板配置筛选出需要展示的属性
    }
  },
  computed: {
    detailRoleList() {
      let path = '/iceDevice/list'.toLowerCase()
      let productModelRole = getRoute(path, this.$store.state.menus) || {}
      let detailRole = getRoleByOperationCode(productModelRole.childList, 'detail')
      return detailRole && detailRole.isPermission === 'Y' ? detailRole.childList : []
    },
    //恢复出厂设置权限
    initDataRole() {
      let val = getRoleByOperationCode(this.detailRoleList, 'initData')
      return val ? val.isPermission == 'Y' : false
    },
    //远程控制
    remoteControlRole() {
      let val = getRoleByOperationCode(this.detailRoleList, 'remoteControl')
      return val ? val.isPermission == 'Y' : false
    },
    //参数设置
    paramsSetRole() {
      let val = getRoleByOperationCode(this.detailRoleList, 'paramsSet')
      return val ? val.isPermission == 'Y' : false
    },
    ...mapState({
      cmdContent: (state) => state.cmdContent
    }),
    DeviceTemperatureWithUnit() {
      console.log('this.deviceTempUnit', this.deviceTempUnit, CToF(this.deviceTemperature))
      let val =
        this.deviceTempUnit === '℉'
          ? parseInt(CToF(this.deviceTemperature))
          : this.deviceTemperature
      return val
    }
  },
  created() {
    this.getDeviceDetail()
    this.getReplyData()
  },
  mounted() {
    this.deviceClipboard = new ClipboardJS('#copyDeviceCode')
    this.communicationClipboard = new ClipboardJS('#copyCommunicationCode')
  },
  destroyed() {
    this.deviceClipboard.destroy()
    this.deviceClipboard.destroy()
    client.unsubscribe(this.upTopic)
    timer && clearTimeout(timer)
  },
  watch: {
    deviceIceStatus() {
      this.getReplyData()
    }
  },
  filters: {
    format,
    formatTime,
    formatNumWithComma
  },
  methods: {
    createImgUrl,
    dec2hex,
    fixNum,
    //远程控制
    remoteControl() {
      this.remoteControlVisible = false
      this.$prompt(`${this.$t('Device.inputPws')}`, `${this.$t('Device.remoteControl')}`, {
        confirmButtonText: this.$t('Common.confirm'),
        cancelButtonText: this.$t('Common.cancel'),
        beforeClose: (action, instance, done) => {
          if (action === 'confirm' && instance.inputValue) {
            console.log('value', instance.inputValue)
            const params = {
              password: instance.inputValue
            }
            this.$ajax
              .post(this.$api.iceDevice.iceDevice_downCmd_check_pwd, params)
              .then((res) => {
                this.remoteControlVisible = res.data
                if (res.data) {
                  done()
                } else {
                  this.$message.warning(`${this.$t('Device.downCmdTips3')}`)
                }
              })
              .catch((err) => {
                console.log(err)
                done()
              })
              .finally(() => {})
          } else {
            done()
          }
        }
      })
    },
    //参数设置
    handleParamsSet() {
      this.paramentsSetVisible = false
      this.$prompt(`${this.$t('Device.inputPws')}`, `${this.$t('Device.paramsSet')}`, {
        confirmButtonText: this.$t('Common.confirm'),
        cancelButtonText: this.$t('Common.cancel'),
        beforeClose: (action, instance, done) => {
          if (action === 'confirm' && instance.inputValue) {
            console.log('value', instance.inputValue)
            const params = {
              password: instance.inputValue
            }
            this.$ajax
              .post(this.$api.iceDevice.iceDevice_downCmd_check_pwd, params)
              .then((res) => {
                this.paramentsSetVisible = res.data
                if (res.data) {
                  done()
                } else {
                  this.$message.warning(`${this.$t('Device.downCmdTips3')}`)
                }
              })
              .catch((err) => {
                console.log(err)
                done()
              })
              .finally(() => {})
          } else {
            done()
          }
        }
      })
    },
    //确认恢复出厂设置
    initSet() {
      this.$prompt(`${this.$t('Device.inputPws')}`, `${this.$t('Device.resetFactoryData')}`, {
        confirmButtonText: this.$t('Common.confirm'),
        cancelButtonText: this.$t('Common.cancel'),
        showConfirmButton: this.info.online === 'online',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm' && instance.inputValue) {
            if (this.info.online !== 'online') return
            const params = {
              deviceId: this.deviceId,
              pwd: instance.inputValue
            }
            const config = {
              headers: {
                'Content-Type': 'application/json'
              }
            }
            this.$ajax
              .post(this.$api.iceDevice.iceDevice_reset, params, config)
              .then((res) => {
                if (res.success) {
                  this.$message.success(`${this.$t('Common.operationSuccess')}`)
                }
              })
              .catch((err) => {
                console.log(err)
              })
              .finally(() => {
                done()
              })
          } else {
            done()
          }
        }
      })
    },
    //数据分割
    spArr(arr, num) {
      //arr是你要分割的数组，num是以几个为一组
      console.log('arr', arr)
      let newArr = [] //首先创建一个新的空数组。用来存放分割好的数组
      for (let i = 0; i < arr.length; ) {
        //注意：这里与for循环不太一样的是，没有i++
        newArr.push(arr.slice(i, (i += num)))
      }
      return newArr
    },
    //解析mqtt数据
    getReplyData() {
      if (this.deviceIceStatus && this.deviceIceStatus.length > 0) {
        this.deviceIceStatus.map((obj) => {
          let itemData = this.spArr(obj.data, 4)
          console.log(itemData)
          for (let i = 0; i < obj.num; i++) {
            let address = obj.start + i
            this.formatData(address, itemData[i])
          }
        })
      }
    },
    filterArr(tempArr, property) {
      for (let i = 0; i < tempArr.length; i++) {
        for (let j = i + 1; j < tempArr.length; j++) {
          if (tempArr[i][property] == tempArr[j][property]) {
            tempArr.splice(j, 1)
            j--
          }
        }
      }
      return tempArr
    },
    //针对柜温和机组状态数据转换
    formatData(locate, data) {
      let address = dec2hex(locate, 4) //地址转化为16进制
      if (address === '0070') {
        console.log('address-0070')
      }

      // let obj = this.stateConfigs.find((x) => x.paramKey === iceParams['0073'][i].code)
      let stateProperty = this.propertyList.find((property) => property.identifier === 'state')
      if (locate === stateProperty.allocated) {
        //机组状态 - 一部分

        let stateArr = []
        let needShowPropertyCopyList = []
        stateProperty.structObjects.forEach((item) => {
          console.log('statePropertyitem', item)
          let res = this.propertyList.find((x) => x.identifier === item.identifier)
          console.log('findRes', res)
          if (res) {
            needShowPropertyCopyList.push(res)
          }
        })
        let hexData = parseInt(data.toString(), 16) //数据转换为10进制

        for (let j = 0; j < needShowPropertyCopyList.length; j++) {
          let res = hexData & ((1 << needShowPropertyCopyList[j].specs.length) - 1)
          let findRes = this.needShowPropertyList.find(
            (item) => item.paramKey === needShowPropertyCopyList[j].identifier
          )
          if (findRes) {
            let iconId = findRes.enumList.find((enumItem) => {
              return enumItem.code == res
            })
              ? findRes.enumList.find((enumItem) => {
                  return enumItem.code == res
                }).iconId
              : ''
            let status = findRes.enumList.find((enumItem) => {
              return enumItem.code == res
            })
              ? findRes.enumList.find((enumItem) => {
                  return enumItem.code == res
                }).name
              : ''
            let NewObj = {
              iconId: iconId,
              name: findRes.paramName,
              status: status,
              code: findRes.identifier
            }
            stateArr.push(NewObj)
          }

          hexData = hexData >>> needShowPropertyCopyList[j].specs.length
        }
        this.statusList = this.filterArr([...stateArr, ...this.statusList], 'code')
      } else if (this.needShowPropertyList.some((x) => x.allocated === locate)) {
        let arr = []
        let hexData = hex_to_dec_sign(data.toString()) //数据转换为10进制
        let obj = this.needShowPropertyList.find((x) => x.allocated === locate)
        //除雾控制
        arr.push({
          iconId: obj.enumList.find((enumItem) => enumItem.code == hexData).iconId,
          name: obj.paramName,
          status: obj.enumList.find((enumItem) => enumItem.code == hexData).name,
          code: obj.identifier
        })
        this.statusList = this.filterArr([...arr, ...this.statusList], 'code')
      } else if (
        locate ===
        this.propertyList.find((property) => property.identifier === 'cabinetTemp').allocated
      ) {
        console.log('0070', data.toString())
        //柜温传感器
        let hexData = hex_to_dec_sign(data.toString())
        this.deviceTemperature = fixNum(hexData, this.deviceTemperatureC)
      } else if (
        locate ===
        this.propertyList.find((property) => property.identifier === 'tempUnit').allocated
      ) {
        // 温度单位:0-华氏; 1-摄氏

        let hexData = hex_to_dec_sign(data.toString())
        console.log('温度单位', hexData, typeof hexData)
        this.deviceTempUnit = hexData === 0 ? '℉' : '℃'
      } else {
        //按照tsl属性下拉框处理
      }
    },
    //获取设备详请
    getDeviceDetail() {
      const params = {
        id: this.deviceId
      }
      return this.$ajax
        .get(this.$api.iceDevice.iceDevice_install_detail, params)
        .then((res) => {
          if (res.data.productKey) {
            this.getStateTemplate(res.data.productKey)
            this.getTemperatureC(res.data.productKey)
          }

          this.info = res.data

          this.deviceIceStatus = {
            currStepNum: res.data.currStepNum,
            currStepType: res.data.currStepType,
            detergentSurplus: res.data.detergentSurplus,
            menuName: res.data.menuName,
            softenerSurplus: res.data.softenerSurplus,
            state: res.data.state,
            totalWater: res.data.totalWater,
            totalElectric: res.data.totalElectric,
            totalStepNum: res.data.totalStepNum,
            totalWorkTime: res.data.totalWorkTime
          }
          this.upTopic = `${topicPrefix}mqtt/${res.data.communicationCode}/up`
          this.downTopic = `${topicPrefix}mqtt/${res.data.communicationCode}/down`
          if (res.data.online === 'online') {
            this.$nextTick(() => {
              this.connectMqttService()
            })
          }
        })
        .catch(() => {})
    },

    //获取产品参数信息模板-状态信息内容
    getStateTemplate(productKey) {
      const params = {
        productKey: productKey
      }
      this.$ajax.get(this.$api.product.iceProduct_params_template_detail, params).then((res) => {
        if (res.data) {
          this.stateConfigs = res.data.stateConfigs || []

          //获取影子设备
          this.getShadow(productKey)
        }
      })
    },
    //获取柜温系数
    getTemperatureC(productKey) {
      this.$ajax
        .get(this.$api.product.product_tsl_property_list, {
          productKey: productKey
        })
        .then((res) => {
          if (res.success) {
            this.propertyList = res.data
            this.deviceTemperatureC =
              res.data.find((property) => property.identifier === 'cabinetTemp').specs
                .coefficient || 0.1
            let needShowPropertyList = []
            console.log('this.propertyList', res.data)
            console.log('this.stateConfigs', this.stateConfigs)
            for (let i = 0; i < res.data.length; i++) {
              for (let j = 0; j < this.stateConfigs.length; j++) {
                if (this.stateConfigs[j].paramKey === res.data[i].identifier) {
                  needShowPropertyList.push({ ...res.data[i], ...this.stateConfigs[j] })
                }
              }
            }
            this.needShowPropertyList = needShowPropertyList
            console.log('needShowPropertyList', needShowPropertyList)
          }
        })
      // const params = {
      //   identifier: 'cabinetTemp',
      //   productKey: productKey
      // }
      // this.$ajax.get(this.$api.iceDevice.iceDevice_property_list, params).then((res) => {
      //   if (res.data) {
      //     this.deviceTemperatureC = res.data.specs.coefficient || 0.1
      //   }
      // })
    },

    //获取影子设备数据,初始化柜温和状态信息
    getShadow(productKey) {
      const params = {
        deviceId: this.deviceId,
        productKey: productKey,
        pageSize: 9999,
        pageNumber: 1
      }
      this.$ajax.get(this.$api.iceDevice.iceDevice_shadow_list, params).then((res) => {
        if (res.data.list) {
          let shadowList = res.data.list
          let arrState = []
          shadowList.forEach((item) => {
            if (item.identifier === 'cabinetTemp') {
              this.deviceTemperature = item.latestValue
                ? fixNum(item.latestValue, item.coefficient)
                : '-'
            } else if (item.identifier === 'tempUnit') {
              console.log('item.latestValue', item.latestValue, typeof item.latestValue)
              this.deviceTempUnit = item.latestValue === '0' ? '℉' : '℃'
            } else if (this.stateConfigs.some((x) => x.paramKey === item.identifier)) {
              let obj = this.stateConfigs.find((x) => x.paramKey === item.identifier)
              console.log('obj', obj)
              arrState.push({
                iconId: obj.enumList.find((enumItem) => enumItem.code === item.latestValue).iconId,
                name: obj.paramName,
                status: obj.enumList.find((enumItem) => enumItem.code === item.latestValue).name,
                code: item.identifier
              })
            }
          })
          this.statusList = arrState
        }
      })
    },
    connectMqttService() {
      client = createMqttClient(this, onMessage(this), onConnect(this), onError(this))
      this.upTopicCmd()
    },
    upTopicCmd() {
      console.log('upTopicCmd', this.upTopic)

      client.subscribe(this.upTopic)
      this.cookStatusLoading = true
      timer = setTimeout(() => {
        this.cookStatusLoading = false
        // this.$message.error(`${this.$t('Common.deviceConnMessage')}`)
        //client.unsubscribe(this.upTopic)
        // this.receiveMessagList.push('下发失败')
      }, 60000)
    },
    // onClipboard(clipboard) {
    //   clipboard.on('success', (e) => {
    //     this.$message.success('复制成功')
    //     e.clearSelection()
    //   })
    //   clipboard.on('error', () => {
    //     this.$message.success('复制失败')
    //   })
    // },
    // copyToBorad(selector) {
    //   navigator.clipboard
    //     .readText()
    //     .then((clipText) => (document.querySelector(selector).innerText += clipText))
    // },
    copyCode() {
      console.log(1111)
      // this.copyToBorad('.deviceCode')
    }
  }
}
function onConnect(self) {
  return function() {
    self.mqttConnectState = mqttState.success
  }
}
function onError(self) {
  return function() {
    self.mqttConnectState = mqttState.fail
  }
}
function onMessage(self) {
  self.cookStatusLoading = true
  return function(topic, message) {
    console.log('message2', topic)
    console.log('message', message.toString())
    let payload
    try {
      payload = JSON.parse(message.toString(), null, 2)
    } catch (err) {
      /* eslint-disable-next-line */
      console.log('err', err)
      payload = {}
    } finally {
      self.cookStatusLoading = false
    }
    console.log('payload', payload)
    if (payload.cmd === 'fail') {
      // this.$message.warning(`${payload.params.erroCmd}:${payload.params.errorInfo}`)
      Message.error(
        `${self.$t('Common.cmdDownFile')}:${payload.params.erroCmd}:${payload.params.errorInfo}`
      )
    } else {
      if (self.cmdContent.cmd === payload.cmd) {
        Message.success(`${self.$t('Common.cmdDownSuccess')}`)
      }

      if (payload.params) {
        let arr = []
        arr = payload.params.holdingRegister.concat(
          payload.params.coilStatus ? payload.params.coilStatus : []
        )
        self.deviceIceStatus = arr
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.info {
  display: flex;
  .info-content {
    width: 100%;
    .info-header {
      display: flex;
      margin-bottom: 24px;
      .btPart {
      }
      .status-icon {
        position: relative;
        width: 24px;
        height: 24px;
        margin-right: 14px;
        .device {
          position: absolute;
          width: 16px;
          height: 16px;
          background-color: #fff;
          border-radius: 50%;
          right: -8px;
          bottom: -5px;
        }
        .device-dot {
          position: absolute;
          left: 2px;
          top: 2px;
        }
      }
      .name {
        margin-right: 8px;
        font-size: 24px;
        color: #333333;
      }
      .address {
        margin-top: 13px;
        color: #333333;
        font-weight: 500;
        .icon {
          width: 12px;
          color: #a1a5ad;
        }
      }
    }
    .info-desc-part {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      align-items: center;

      .info-desc {
        width: calc(100% - 204px);
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        .info-desc-part-item {
          margin-bottom: 8px;
          width: 33%;
          .statusName {
            color: #333333;
            line-height: 22px;
            margin-right: 8px;
          }
        }
      }
      .deviceStatus {
        width: 204px;
        margin-top: 0;
        display: flex;
        justify-content: right;
        //align-items: center;
        .temperature-card {
          height: 140px;
          width: 180px;
          border-radius: 16px;
          background-image: url('../../../assets/refrigeration_pic_current_temperaturel_bg.jpg');
          background-repeat: no-repeat;
          background-size: 100% 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          .device-temperature {
            font-family: Barlow-SemiBold;
            font-size: 36px;
            color: #333333;
            line-height: 36px;
            font-weight: 600;
          }
          .device-temperature-tips {
            font-family: PingFangSC-Regular;
            color: #666666;
            font-weight: 400;
          }
        }
        //.deviceShadow {
        //  width: 332px;
        //  height: 208px;
        //  border-radius: 16px;
        //  border: 1px solid #dcdfe6;
        //}
      }
    }

    .icon-copy {
      margin-left: 5px;
      color: $--color-blue;
      cursor: pointer;
    }
  }
}
/deep/ .el-tabs .el-tabs__item {
  font-size: 16px;
  font-weight: 400;
  color: rgba(51, 51, 51, 0.65);
  &.is-active {
    color: #2046c7;
    font-weight: 600;
  }
}
</style>
